import axiosInstance from "./api/axiosInstance";

const purchaseContract = async (purchaseData) => {
    // O método de pagamento é fixo em 3 (DEPÓSITO)
    const payMethodCode = 3;
    const response = await axiosInstance.post(
        `contract?payMethod=${payMethodCode}`,
        purchaseData
    );
    return response.data; // Retorna os dados da resposta para o componente
};

const cancelContract = async (contractId) => {
    const response = await axiosInstance.post(
        `contractreturn/${contractId}/cancel`,
        null // Sem corpo na requisição
    );
    return response.data;
};

const repurchaseWithBalance = async (contractsToBuy) => {
    const response = await axiosInstance.post(
        'contractreturn/repurchase-with-balance',
        { contractsToBuy } // O backend espera um objeto com a propriedade 'contractsToBuy'
    );
    return response.data;
};

const getAvailabilityAnalysis = async (clientId) => {
    const response = await axiosInstance.get(
        `contract/availability-analysis/${clientId}`
    );
    return response.data;
};

const simulateProfit = async (qtt) => {
    const response = await axiosInstance.get(`contract/simulate/${qtt}`);
    return response.data;
};

const getContractPlans = async () => {
    const response = await axiosInstance.get('goldenvariable/plans');
    return response.data;
};

export const contractService = {
    purchaseContract,
    cancelContract,
    repurchaseWithBalance,
    getAvailabilityAnalysis,
    simulateProfit,
    getContractPlans
};